import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const homeFor = (user) => {
  if (!user) return "/login";
  if (user.rol === "super_admin") return "/superadmin/empresas";
  if ((user.es_aprobador_gerencia || user.es_miembro_gerencia) && user.rol === "worker") {
    return "/admin/vacaciones";
  }
  if (user.rol === "worker") return "/fichar";
  return "/admin";
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = cargando, false = no autenticado

  useEffect(() => {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 12000);
    api
      .get("/auth/me", { signal: ctrl.signal, timeout: 12000 })
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => clearTimeout(t));
    return () => {
      clearTimeout(t);
      ctrl.abort();
    };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) {
      return { requires_2fa: true, temp_token: data.temp_token, expires_in: data.expires_in };
    }
    localStorage.setItem("token", data.access_token);
    setUser(data.user);
    return { requires_2fa: false, user: data.user };
  };

  const verify2fa = async (tempToken, code) => {
    const { data } = await api.post("/auth/2fa/verify", { temp_token: tempToken, code });
    localStorage.setItem("token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignorar
    }
    localStorage.removeItem("token");
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, login, verify2fa, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
